import React from "react";
import ContentWrapper from "../../common/ContentWrapper";
import Carousel from "../../common/carousel/Carousel";
import BannersFetcher from "../../common/carousel/BannersFetcher";
import FlashOdds from "../flash-odds/FlashOdds";

export default function DailyFlashOdds() {
    return (
        <ContentWrapper columns="1">
            <div className="c_50">
                <BannersFetcher renderItem={(data) => {
                    if (data == null || data.carouselBanners?.length === 0) {
                        return null;
                    }
                
                    const banners = data.carouselBanners;

                    return <Carousel banners={banners} />;
                }} />
                <FlashOdds />
            </div>
        </ContentWrapper>
    );
}
